import type { TokenInfoResponse } from '@yoop/data-access-model';
import { ChoiceTagType, ChoiceTagValue } from '@yoop/server-model/inventory-category';
import { TokenType } from '@yoop/server-model/token-info';

export const getTokenType = (token: TokenInfoResponse): TokenType => {
  const selectedType = token.categoryDetail?.choiceSets
    ?.find((_choiceSet) => _choiceSet.choiceTagTypes?.includes(ChoiceTagType.AGE_BASED))
    ?.selectedChoice?.tags?.find((_tag) => _tag.type === ChoiceTagType.AGE_BASED)?.value;

  switch (selectedType) {
    case ChoiceTagValue.SENIOR:
      return TokenType.SENIOR;
    case ChoiceTagValue.CHILD:
      return TokenType.CHILD;
    case ChoiceTagValue.ADULT:
    default:
      return TokenType.ADULT;
  }
};
